import React from 'react'

import { Field } from 'formik'

import { Button, Div, P, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { ModalBody, ModalFooter, ModalTitle, useCloseModal } from '@driftt/tide-modal'
import { access } from '@driftt/traffic-control'

import C from '../NotificationsDefaultSettings/constants'
import CheckboxRow from '../NotificationsDefaultSettings/form/CheckboxRow'

import styles from './styles.module.css'

interface SavedFilterModalProps {
  formikValues: Record<string, any>
  selectedFilter: any
  onBack: () => void
  isSubmitting: boolean
  numUnsavedChanges: number
  hidden: boolean
}

const NotificationsSavedFilterSettings = (props: SavedFilterModalProps) => {
  const closeModal = useCloseModal()
  const { selectedFilter, numUnsavedChanges, hidden } = props
  const hasSavedViewNotifications = access.hasGates('saved_filters_push_notifications')

  const onSavedFilterChange = (form: any, field: any) => {
    const { setFieldValue } = form
    setFieldValue(field.name, !field.value)
  }

  return (
    <div hidden={hidden}>
      {selectedFilter && (
        <>
          <ModalTitle>
            <Div onClick={props.onBack} className={styles.backButton}>
              <Icon name="arrow-1-left" width={5} className={styles.backArrow} />
              <Span className={styles.backText}>All notifications</Span>
            </Div>
            <Div>{selectedFilter.name}</Div>
          </ModalTitle>
          <ModalBody className={styles.modalBody}>
            {hasSavedViewNotifications && (
              <Field name={`savedFilters.${C.SAVED_FILTER_TYPE.PUSH}-${selectedFilter.id}`}>
                {(props: any) => (
                  <CheckboxRow
                    {...props}
                    onSavedFilterChange={onSavedFilterChange}
                    content={
                      <Div>
                        Push notifications
                        <P className={styles.subtext}>
                          Get notified on desktop & mobile when a site visitor from any account in
                          this filter set is active on your site, once every 5 minutes.
                        </P>
                      </Div>
                    }
                  />
                )}
              </Field>
            )}
            <Field name={`savedFilters.${C.SAVED_FILTER_TYPE.EMAIL}-${selectedFilter.id}`}>
              {(props: any) => (
                <CheckboxRow
                  {...props}
                  onSavedFilterChange={onSavedFilterChange}
                  content={
                    <Div>
                      Daily digest emails
                      <P className={styles.subtext}>
                        Get notified about all site visitors activities from any account in this
                        filter set once every 24 hours at 7 am.
                      </P>
                    </Div>
                  }
                />
              )}
            </Field>
          </ModalBody>
          <ModalFooter className={styles.modalFooter}>
            <Button className={styles.saveButton} submit>
              Save
            </Button>
            <Button type="tertiary" onClick={closeModal}>
              Cancel
            </Button>
            {numUnsavedChanges > 0 && (
              <Div className={styles.unsavedChangesText}>
                {numUnsavedChanges} unsaved change{numUnsavedChanges > 1 && 's'}
              </Div>
            )}
          </ModalFooter>
        </>
      )}
    </div>
  )
}

export default NotificationsSavedFilterSettings
